import React, {PureComponent} from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Chip,
  Tooltip
} from "@material-ui/core";
import { withTheme } from "@material-ui/core/styles";
import UserInfoTable from "../UserInfo/UserInfoTable";


class UserInfoDialog extends PureComponent{
  constructor(props){
    super(props)
  }

  render(){
      const { theme, user, open, onClose } = this.props;

      return (
        <Dialog
          maxWidth={"xl"}
          fullWidth={true}
          open={open}
        >
          <DialogTitle>Informacion del Usuario</DialogTitle>
          <DialogContent>
            <UserInfoTable user={user}/>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Aceptar">
              <Button
                variant="contained"
                color="secondary"
                onClick={onClose}
              >
                Aceptar
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
      );
    }
  
}

export default withTheme(UserInfoDialog)


// WEBPACK FOOTER //
// ./src/components/Dialog/UserInfoDialog.js